import { render, staticRenderFns } from "./ElTextarea.vue?vue&type=template&id=389f5100"
import script from "./ElTextarea.vue?vue&type=script&lang=js"
export * from "./ElTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports